import "./App.css";
import { startRecording, stopRecording } from "./audio";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Listen from "./components/Listen";
import Landing from "./components/Landing";
import Auth from "./components/Auth";
import { useAuth } from "./hooks/useAuth";
import Artist from "./components/Artist";
import NavBar from "./components/NavBar";
import {
  WagmiConfig,
  createClient,
  defaultChains,
  configureChains,
} from 'wagmi'

import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'

import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import MySounds from "./components/MySounds";
import Discover from "./components/Discover";

// Configure chains & providers with the Alchemy provider.
// Two popular providers are Alchemy (alchemy.com) and Infura (infura.io)
const { chains, provider, webSocketProvider } = configureChains(defaultChains, [
  alchemyProvider({ apiKey: 'Jyl9KfrBV772HPD5tLgpZKLbOMWtnlxq' }),
  publicProvider(),
])

// Set up client
const client = createClient({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    // new CoinbaseWalletConnector({
    //   chains,
    //   options: {
    //     appName: 'wagmi',
    //   },
    // }),
    // new WalletConnectConnector({
    //   chains,
    //   options: {
    //     qrcode: true,
    //   },
    // }),
    // new InjectedConnector({
    //   chains,
    //   options: {
    //     name: 'Injected',
    //     shimDisconnect: true,
    //   },
    // }),
  ],
  provider,
  webSocketProvider,
})

function App() {
  const { isAuthenticated, accessToken, logUserOut, handleSession, confirmMFA, logUserIn } = useAuth(); 
  return (
    <WagmiConfig client={client}>      
      <Router>
        <NavBar accessToken={accessToken} logUserOut={logUserOut} />
        <Routes>
          <Route path="/" element={<Discover />} />
          <Route
            path="/auth"
            element={<Auth handleSession={handleSession} confirmMFA={confirmMFA} logUserIn={logUserIn} isAuthenticated={isAuthenticated} />}
          />
          <Route path="/discover" element={<Discover />} />
          <Route
            path="/artist"
            element={<Artist accessToken={accessToken} handleSession={handleSession} confirmMFA={confirmMFA} logUserIn={logUserIn} isAuthenticated={isAuthenticated} />}
          />
          <Route path="/:id" element={<Listen />} />
          <Route path="/mysounds" element={<MySounds />} />
        </Routes>
      </Router>
    </WagmiConfig>
  );
}

export default App;
